var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"387624e112af5669398637d740e0dd48797b6ae7"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["help-center@klaviyo-1"]={id:"387624e112af5669398637d740e0dd48797b6ae7"};
      